// statusOptions.js (o en el mismo BillingForm/BillingItem)
export const STATUS_OPTIONS = [
  { key: "pending", value: "pending", text: "Pendiente" },
  { key: "paid", value: "paid", text: "Pagado" },
  { key: "cancelled", value: "cancelled", text: "Cancelado" },
];
